var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 752 752",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9b9b9b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m376 320.5c2.043 0 3.6992-1.6562 3.6992-3.6992v-14.801c0-2.043-1.6562-3.6992-3.6992-3.6992s-3.6992 1.6562-3.6992 3.6992v14.801c0 2.043 1.6602 3.6992 3.6992 3.6992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.38 328.98-50.57 50.562c-0.050782 0.050781-0.066406 0.11719-0.11719 0.17188-5.6992-4.5664-12.832-7.418-20.691-7.418-18.359 0-33.297 14.941-33.297 33.297 0 18.359 14.941 33.297 33.297 33.297 18.359 0 33.297-14.941 33.297-33.297 0-7.8594-2.8555-15-7.4297-20.703 0.058593-0.050781 0.125-0.066406 0.17187-0.11719l50.57-50.562c1.4414-1.4414 1.4414-3.7891 0-5.2305-1.4414-1.4453-3.7812-1.4453-5.2305 0zm-71.379 102.52c-14.281 0-25.898-11.617-25.898-25.898s11.617-25.898 25.898-25.898 25.898 11.617 25.898 25.898-11.617 25.898-25.898 25.898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 253.91c-99.961 0-181.29 81.332-181.29 181.29v59.199c0 2.043 1.6562 3.6992 3.6992 3.6992h355.19c2.043 0 3.6992-1.6562 3.6992-3.6992v-59.199c0-99.961-81.32-181.29-181.29-181.29zm173.89 236.79h-347.79v-55.496c0-95.887 78.008-173.89 173.89-173.89 95.883 0 173.89 78.008 173.89 173.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.7 405.6c0 2.043 1.6562 3.6992 3.6992 3.6992h14.801c2.043 0 3.6992-1.6562 3.6992-3.6992 0-2.043-1.6562-3.6992-3.6992-3.6992h-14.801c-2.0391-0.003906-3.6992 1.6562-3.6992 3.6992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.61 401.9h-14.801c-2.043 0-3.6992 1.6562-3.6992 3.6992 0 2.043 1.6562 3.6992 3.6992 3.6992h14.801c2.043 0 3.6992-1.6562 3.6992-3.6992 0-2.0391-1.6562-3.6992-3.6992-3.6992z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWidget);
export default __webpack_public_path__ + "static/media/empty-widget.76cbd00cb2e417ba4a44ce68fca57dcf.svg";
export { ForwardRef as ReactComponent };